var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Navigation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    clipPath: "url(#clip-Navigation)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_172",
    "data-name": "Pfad 172",
    d: "M376.55,1283.2a2.352,2.352,0,1,1,2.348-2.352,2.35,2.35,0,0,1-2.348,2.352m34.091-3.394H381.25v2.082h29.391Zm-34.091,15.15a2.352,2.352,0,1,1,2.348-2.352,2.35,2.35,0,0,1-2.348,2.352m34.091-3.393H381.25v2.083h29.391Zm-34.091,15.15a2.352,2.352,0,1,1,2.348-2.352,2.35,2.35,0,0,1-2.348,2.352m34.091-3.393H381.25v2.083h29.391Z",
    transform: "translate(-362.197 -1262.604)",
    fill: "#234053",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.2e5f5d8556d3669dd76516164fc682bd.svg";
export { ForwardRef as ReactComponent };